<!--
 * @Description: 上传图片组件
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-20 15:42:03
 * @LastEditTime: 2019-10-25 10:02:32
 -->
<template>
  <div>
    <el-upload
      ref="upload"
      v-viewer
      action="#"
      class="v_viewer"
      :class="{hide:hideUpload}"
      :multiple="limit === 1 ? false : multiple"
      :list-type="listType"
      :accept="accept"
      :disabled="disabled"
      :limit="limit"
      :on-preview="onPreview"
      :on-remove="onRemove"
      :on-success="onSuccess"
      :before-upload="beforeUpload"
      :http-request="httpRequest"
      :on-exceed="onExceed"
      :on-change="onChange"
      :file-list="fileList"
      :before-remove="beforeRemove"
    >
      <i ref="uploadBtn" class="el-icon-plus" />
    </el-upload>
  </div>
</template>
<script>
import { upload, delImg, download } from '@/api/common'

export default {
  name: 'Upload',
  props: {
    // 是否可以多选
    multiple: { type: Boolean, default: true },
    // 是否显示已上传文件列表
    showFileList: { type: Boolean, default: true },
    //  可上传的图片类型
    accept: { type: String, default: 'image/png, image/jpeg' },
    // 是否禁用
    disabled: { type: Boolean, default: false },
    // 最大允许上传个数
    limit: { type: Number, default: 3 },
    // 文件列表的类型
    listType: { type: String, default: 'picture-card' },
    // 图片的最大值(Mb)
    maxSize: { type: Number, default: 2 },
    // 项目中文件类型
    methodName: { type: String, required: true },
    // 如果传入数组返回结果就是数组，如果传入字符串，返回结果就是字符串
    imgList: { type: [String, Array], required: true },
    // 是否吧删除修改成上传
    isEdit: { type: Boolean, default: false }
  },
  data() {
    return {
      hideUpload: false,
      fileList: []
    }
  },
  watch: {
    imgList: {
      immediate: true,
      handler(val) {
        let img_list
        // 判断如果是字符串就转成数组，清楚数组空值
        typeof val === 'string'
          ? (img_list = val.split(',').filter(n => n))
          : (img_list = val)
        this.fileList = img_list.map(ele => ({
          url: `${download}${ele}`,
          response: { fileId: ele }
        }))
        this.isUpBtn(this.fileList)
      }
    }
  },
  mounted() {
    if (this.isEdit) {
      setTimeout(() => {
        this.noDel()
      }, 1000)
    }
  },
  updated() {
    if (this.isEdit) {
      this.$nextTick(() => {
        this.noDel()
      })
    }
  },
  methods: {
    // 点击文件列表中已上传文件时的钩子
    onPreview(file) {
      const viewer = this.$el.querySelector('.v_viewer').$viewer
      const imgIdAll = viewer.images.map(ele => this.getUrl('params', ele.src))
      const index = imgIdAll.indexOf(this.getUrl('params', file.url))

      setTimeout(() => {
        viewer.view(index === -1 ? 0 : index)
      }, 100)
    },
    // 文件列表移除文件时的钩子
    onRemove(file, fileList) {
      this.fileList = fileList
      this.isUpBtn(fileList)
      this.updateImgList()
    },
    // 文件上传成功时的钩子
    onSuccess(response, file, fileList) {
      const _this = this
      _this.fileList.push({
        url: `${download}${response.fileId}`,
        response: { fileId: response.fileId }
      })
      this.updateImgList()
    },
    // 上传文件之前的钩子
    beforeUpload(file) {
      const _this = this
      const isLt2M = file.size / 1024 / 1024 < _this.maxSize

      if (!isLt2M) {
        this.$message.error(`上传图片的大小不能超过 ${this.maxSize}MB!`)
      }
      return isLt2M
    },
    // 自定义上传
    httpRequest(options) {
      // console.log('options', options)
      const formData = new FormData()
      formData.append('file', options.file)
      upload(
        {
          data: formData,
          methodName: this.methodName
        },
        {
          // 添加上传进度条
          onUploadProgress: progressEvent => {
            const complete =
              ((progressEvent.loaded / progressEvent.total) * 100) | 0
            options.onProgress({ percent: complete })
          }
        }
      )
        .then(res => {
          // console.log(res)
          options.onSuccess({ fileId: res.fileId }) // 上传成功出现成功提示，同时把id传入
        })
        .catch(() => {
          options.onError()
        })
    },
    // 文件超出个数限制时的钩子
    onExceed(files, fileList) {
      this.$message({
        showClose: true,
        message: '超出最大上传数量',
        type: 'error'
      })
    },
    // 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
    onChange(file, fileList) {
      this.isUpBtn(fileList)
    },
    // 判断是否隐藏上传按钮
    isUpBtn(fileList) {
      this.hideUpload = fileList.length >= this.limit
    },
    // 获取图片数组中的id，路径拼接
    getImageId(list) {
      if (list) {
        return list.map(ele => ele.response.fileId)
      } else {
        return []
      }
    },
    // 获取url参数
    getUrl(name, url) {
      const urlStr = url || window.location.search
      if (urlStr.indexOf('?') !== -1) {
        const arr = urlStr.split('?')[1].split('&')
        const obj = {}
        arr.map(ele => {
          const itemArr = ele.split('=')
          obj[itemArr[0]] = itemArr[1]
        })
        if (name) {
          return obj[name]
        }
        return obj
      }
    },
    // 更新到父组件
    updateImgList() {
      const returnType = typeof this.imgList
      let fileList = this.fileList.map(ele => ele.response.fileId)
      if (returnType === 'string') {
        fileList = fileList.join(',')
      }
      this.$emit('update:imgList', fileList)
    },
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      if (this.isEdit) {
        this.$refs.uploadBtn.click()
      // 下边语句不执行，file中没有response.fileId
      // } else {
      //   return this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     delImg({
      //       fileId: file.response.fileId
      //     }).then(res => {
      //       return true
      //     }).catch(() => {
      //       return false
      //     })
      //   })
      }
    },
    // 把删除按钮修改为上传按钮
    noDel() {
      this.$nextTick(() => {
        try {
          const el = this.$el.querySelector('.el-icon-delete')
          el.className = 'el-icon-upload'
        } catch (error) {
          return error
        }
      })
    }
  }
}
</script>
<style lang="scss">
.hide .el-upload--picture-card {
  display: none;
}
.hide .el-icon-close-tip {
  display: none;
}
</style>
